export const Error = () => {
  return <div>Some error occurred</div>
}

